import React from "react";
import { FormattedMessage } from "react-intl";

import Service from "./service";

const InternationalServices = ({
  disabled,
  productCode,
  initialServices,
  getFieldDecorator,
}) => {
  return (
    <>
      {productCode !== "ERD" ? (
        <Service
          disabled={disabled}
          label={
            <FormattedMessage
              id="consignment.services.timeSlotBooking"
              defaultMessage="Time-slot booking"
            />
          }
          fieldName="timeSlotBooking"
          getFieldDecorator={getFieldDecorator}
          initialValue={initialServices && initialServices.timeSlotBooking}
        />
      ) : (
        <></>
      )}
      <Service
        disabled={disabled}
        label={
          <FormattedMessage
            id="consignment.services.preAdviseDelivery"
            defaultMessage="Pre-advise delivery"
          />
        }
        fieldName="preAdviseDelivery"
        getFieldDecorator={getFieldDecorator}
        initialValue={initialServices && initialServices.preAdviseDelivery}
      />
    </>
  );
};

export default InternationalServices;
